import SHEEP_BOMB_IMAGE_URL from './sheep.webp';
export { SHEEP_BOMB_IMAGE_URL };
export const SHEEP_BOMB_SPRITESHEET_DATA = {
    frames: {
        'sheep0001.png': {
            frame: { x: 1, y: 1, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0002.png': {
            frame: { x: 243, y: 1, w: 256, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 256, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0003.png': {
            frame: { x: 501, y: 1, w: 265, h: 219 },
            rotated: false,
            trimmed: false,
            spriteSourceSize: { x: 0, y: 0, w: 265, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0004.png': {
            frame: { x: 1, y: 222, w: 261, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 261, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0005.png': {
            frame: { x: 264, y: 222, w: 256, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 256, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0006.png': {
            frame: { x: 522, y: 222, w: 251, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 251, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0007.png': {
            frame: { x: 1, y: 443, w: 246, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 246, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0008.png': {
            frame: { x: 249, y: 443, w: 243, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 243, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0009.png': {
            frame: { x: 494, y: 443, w: 241, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 241, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0010.png': {
            frame: { x: 737, y: 443, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0011.png': {
            frame: { x: 1, y: 664, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0012.png': {
            frame: { x: 243, y: 664, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0013.png': {
            frame: { x: 485, y: 664, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0014.png': {
            frame: { x: 727, y: 664, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0015.png': {
            frame: { x: 1, y: 885, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0016.png': {
            frame: { x: 243, y: 885, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0017.png': {
            frame: { x: 485, y: 885, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0018.png': {
            frame: { x: 727, y: 885, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0019.png': {
            frame: { x: 1, y: 1106, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0020.png': {
            frame: { x: 243, y: 1106, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0021.png': {
            frame: { x: 485, y: 1106, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0022.png': {
            frame: { x: 727, y: 1106, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0023.png': {
            frame: { x: 1, y: 1, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0024.png': {
            frame: { x: 1, y: 1, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0025.png': {
            frame: { x: 1, y: 1, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        },
        'sheep0026.png': {
            frame: { x: 1, y: 1, w: 240, h: 219 },
            rotated: false,
            trimmed: true,
            spriteSourceSize: { x: 0, y: 0, w: 240, h: 219 },
            sourceSize: { w: 265, h: 219 },
            anchor: { x: 0.509434, y: 0.977169 }
        }
    },
    animations: {
        animation: [
            'sheep0001.png',
            'sheep0002.png',
            'sheep0003.png',
            'sheep0004.png',
            'sheep0005.png',
            'sheep0006.png',
            'sheep0007.png',
            'sheep0008.png',
            'sheep0009.png',
            'sheep0010.png',
            'sheep0011.png',
            'sheep0012.png',
            'sheep0013.png',
            'sheep0014.png',
            'sheep0015.png',
            'sheep0016.png',
            'sheep0017.png',
            'sheep0018.png',
            'sheep0019.png',
            'sheep0020.png',
            'sheep0021.png',
            'sheep0022.png',
            'sheep0023.png',
            'sheep0024.png',
            'sheep0025.png',
            'sheep0026.png'
        ]
    },
    meta: {
        app: 'https://www.codeandweb.com/texturepacker',
        version: '1.1',
        image: SHEEP_BOMB_IMAGE_URL,
        format: 'RGBA8888',
        size: { w: 978, h: 1326 },
        scale: '0.35',
        smartupdate: '$TexturePacker:SmartUpdate:f384cb0df8673836ca800aa0087fb0be:bfe5a70dca4ab29f285f7b2de59876f3:a02d5ee6262bd8732bc34b293ec3862a$'
    }
};
